<template>
  <dl class="myo_search_list">
    <dt>{{ i18n.myoffice.myoSearchForm.Line }}</dt>
    <dd>
      <vSelect :options="tree" :reduce="value => value.id" :modelValue="selection" @update:modelValue="get_tree_node" :clearable="false" class="custom-vselect" ></vSelect>
    </dd>
  </dl>

</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "legForm",
  components : {
    vSelect
  },
  props : {
    tree_node : {
      type    : String,
      default : 'UNI'
    },
  },
  data: () => ({
        i18n: window.i18n,
        selection : 'UNI',
        tree      : [ { "id": "BIN", "label": i18n.myoffice.Supportline }, { "id": "UNI", "label": i18n.myoffice.Recommendline } ],
  }),
  mounted() {
    this.selection = this.tree_node;
  },
  methods: {
    get_tree_node(value) {
      this.selection = value
      this.$emit('get_tree_node', value);
    },
  }

}
</script>

<style scoped>

</style>
